/**
 * NOTE: ProtocolLogger child classes that are platform-specific can be decorated with @Injectable which will allow dependency injection!
 */
export class ProtocolLogger {
  constructor() {
    this.assigned = false;
  }
  get protocol() {
    if (!this.assigned) throw new Error('ProtocolLogger.protocol must not be accessed before calling assignToProtocol()!');
    return this._protocol;
  }
  get name() {
    return this.protocol.name;
  }
  assignToProtocol(protocol) {
    if (this.assigned) throw new Error('Logger is already assigned!');
    this._protocol = protocol;
    this.assigned = true;
  }
  setEnabled(enabled) {
    this.enabled = enabled;
  }
}